// src/App.js
import React from 'react';
import EdvisorRankPredictor  from "../src/Component/RankPradictor";
import './App.css';

function App() {
  return (
    <div className="App">
      <EdvisorRankPredictor />
    </div>
  );
}

export default App;